var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5875C8.30516e-09 16.3975 0.0700003 16.2075 0.22 16.0575L6.74 9.5375C7.22 9.0575 7.22 8.2775 6.74 7.7975L0.220001 1.2775C-0.069999 0.9875 -0.069999 0.5075 0.220001 0.2175C0.510001 -0.0725 0.990001 -0.0725 1.28 0.2175L7.8 6.7375C8.86 7.7975 8.86 9.5275 7.8 10.5975L1.28 17.1175C0.99 17.4075 0.51 17.4075 0.22 17.1175C0.0800003 16.9675 -8.30516e-09 16.7775 0 16.5875Z",
    fill: "#FCEEE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.dc16fa315385f9e6cb8668846f69e088.svg";
export { ForwardRef as ReactComponent };